import useReveal from "@/hooks/useReveal";

const PILLARS = [
  {
    id: "heritage",
    title: "Heritage as a living art.",
    text: "We work alongside historians, conservationists, and royal households to bring you into traditions still being practiced — not merely observed.",
  },
  {
    id: "privacy",
    title: "Privacy by design.",
    text: "Our journeys are private from the first call to the final farewell. No groups, no fixed departures, no compromise on the texture of your day.",
  },
  {
    id: "tread-softly",
    title: "Tread softly.",
    text: "We commit a portion of every itinerary to artisan livelihoods, monastic conservation, and the protection of fragile cultural ecosystems.",
  },
];

export default function AboutPillars() {
  const r = useReveal();
  return (
    <section ref={r} className="relative py-32 md:py-40 bg-ivory-alt">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="eyebrow mb-6">Our Commitments</div>
        <h2 className="font-serif text-5xl md:text-6xl tracking-tight font-light mb-20 max-w-3xl">
          Three quiet promises, kept on every journey.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {PILLARS.map((p, i) => (
            <div key={p.id} className="border-t border-line-dark pt-8">
              <div className="font-serif text-3xl text-goldleaf mb-6">
                0{i + 1}
              </div>
              <h3 className="font-serif text-2xl md:text-3xl font-light leading-tight mb-5">
                {p.title}
              </h3>
              <p className="text-ink/70 font-light leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
